import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import IconButton from 'Common/Components/IconButton';
import { TrashIcon } from '../../styled';
import ModalWarning from 'Common/Components/ModalWarning';
import { selectAgentList, selectAgentsSelected } from 'store/Agents/selectors';
import selectModal from 'store/modals/selectors';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';

const DeleteButton = ({ markToDelete }) => {
  const [showWarning, setShowWarning] = useState(false);
  const agentsSelected = useSelector(selectAgentsSelected);
  const agents = useSelector(selectAgentList);
  const showDetail = useSelector((state) => selectModal(state, MODAL_AGENT_DETAIL));
  const canDelete = !showDetail && agents.length > 0;
  const message = 'Please select one Agent';

  const handleClick = () => {
    if (canDelete) {
      if (agentsSelected.length > 0) markToDelete(agentsSelected[0]);
      else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <IconButton icon={ <TrashIcon /> } title="Delete" onClick={ handleClick } disabled={ !canDelete } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Delete" description={ message } /> }
    </>
  );
};

export default DeleteButton;
